import script from "./Legacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Legacy.vue?vue&type=script&lang=ts&setup=true"

import "./Legacy.vue?vue&type=style&index=0&id=3754304d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3754304d"]])

export default __exports__